

async function doCC(params) {
    if (typeof params.domain !== 'string') {
        return;
    }
    const URL = params.domain + '/cc';
    const payload = {
        lfid: typeof params.fid === 'string' ? params.fid : null,
        cfid: typeof params.cfid === 'string' ? params.cfid : null,
    };
    const body = JSON.stringify(payload);
    await fetch(URL, {
        method: 'POST',
        contentType: 'application/json',
        credentials: 'include',
        body: body,
    });
}

export default doCC;
